import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Footer from '../../components/Footer';
import Dropdown from '../../components/Dropdown';
import InputField from '../../components/InputField';
import CalculationResultPart from '../../components/CalculationResultPart';
import { Helmet } from "react-helmet-async";
import { Link } from 'react-router-dom';
import { ARAC_DEGER_OPTIONS, ARAC_DEGER_HASAR_BOYUTLARI } from '../../constants/constants';
import Header from '../../components/Header';

const faqs = [
	{
		question: "Araçlar modern yaşamın vazgeçilmez unsurlarından biri haline gelmiştir. Ancak bu faydalı ulaşım aracı, aynı zamanda önemli bir yatırım kalemidir. Sahip olduğumuz araçlar, satın alındıktan sonra zaman içerisinde değer kaybeder. Bu değer kaybı, normal kullanım ve yaşlanmanın doğal bir sonucu olsa da, kazalar sonucu oluşan hasarlar bu süreci önemli ölçüde hızlandırır. Araç değer kaybı kavramı, bu noktada önem kazanmaktadır.",
	},
	{
		question: "Kazalarda maddi tazminat hesaplanırken, sadece onarım masrafları değil, aracın değer kaybı da göz önünde bulundurulur. Araç değer kaybı, kazaya bağlı olarak işlem gören aracın ikinci el piyasasındaki değer kaybını ifade eder. Bu ekonomik kayıp, Yargıtay kararları ile de desteklenmektedir. Kazada kusurlu bulunan taraf, karşı tarafın aracında oluşan değer kaybını tazmin etmekle yükümlüdür.",
	},
	{
		question: "Araç değer kaybı hesaplaması çeşitli faktörlere bağlı olarak değişkenlik göstermektedir. Bunlar:",
		answer: ["<strong>Kazanın Şiddeti:</strong> Daha ağır hasar bırakacak kazalarda, aracın değer kaybı oranı da artacaktır.", "<strong>Marka ve Model:</strong> Lüks veya daha az bulunan araçların değer kaybı, yaygın modellere göre daha düşük oranda gerçekleşebilir.", "<strong>Hasarın Boyutu:</strong> Araçta meydana gelen hasarın kapsamı ve onarımının zorluğu, değer kaybını etkileyen önemli faktörlerdendir.", "<strong>Aracın Yaşı ve Km Durumu:</strong> Kazaya karışan aracın yaşı ve kilometresi ne kadar düşükse, değer kaybı oranı da o kadar yüksek olacaktır.", "<strong>Kusur Oranı:</strong> Tarafların kusur oranına göre değer kaybı hesaplamaları yapılmaktadır."],
	},
	{
		question: "Araç değer kaybı hesaplaması için uzman bilirkişi raporları esas alınır. Bu raporlarda, kazada hasar gören aracın marka, model, yaşı, kilometresi, kazadan önceki piyasa değeri ve hasarın boyutu gibi unsurlar detaylı bir şekilde incelenerek değer kaybı oranı tespit edilir.",
	},
	{
		question: "Araç değer kaybı tazminatı, kazada zarara uğrayan taraf için önemli bir maddi destek sağlar. Bu tazminat ile hasar gören aracın ikinci el piyasasındaki değer kaybı telafi edilebilir. Sağlıklı bir tazminat süreci için, uzman bir avukatın desteği alınması faydalı olacaktır. Avukatlar, bilirkişi raporlarının doğruluğunu kontrol edebilir, gerekli işlemleri başlatabilir ve aracın değer kaybının tazmin edilmesi için hukuki süreçleri yürütebilir.",
	},
	{
		question: "Sonuç olarak, araç değer kaybı kavramı kazalarda maddi tazminat hesaplamalarında önemli bir yere sahiptir. Kazaya sebebiyet veren tarafın, karşı tarafın aracında meydana gelen değer kaybını tazmin etme sorumluluğu bulunmaktadır. Sağlıklı bir tazminat süreci için ise uzman bilirkişi raporlarının alınması ve avukat desteği alınması önerilmektedir. Böylece kazada uğranılan maddi kayıpların en aza indirilmesi sağlanabilir.",
	}
];

const AracDegerKaybiHesaplama = () => {
	const [hideAll, setHideAll] = useState(false);
	const [results, setResults] = useState([]);
	const [calculated, setCalculated] = useState(false);

	const [aracRayic, setAracRayic] = useState(null);
	const [hasarMiktari, setHasarMiktari] = useState(null);
	const [aracKilometreKatsayi, setAracKilometreKatsayi] = useState();
	const [hasarKatsayi, setHasarKatsayi] = useState();

	const location = useLocation();
	const navigate = useNavigate();

	useEffect(() => {
		const query = new URLSearchParams(location.search);

		if (query.toString()) {
			const parsedResults = query.get('results');
			if (parsedResults) {
				setResults(JSON.parse(decodeURIComponent(atob(parsedResults))));
			}

			setHasarMiktari(Number(decodeURIComponent(atob(query.get('hasar_miktari') || ''))));
			setAracRayic(Number(decodeURIComponent(atob(query.get('arac_rayic') || ''))));
			setAracKilometreKatsayi(Number(decodeURIComponent(atob(query.get('arac_kilometre_katsayi') || ''))));
			setHasarKatsayi(Number(decodeURIComponent(atob(query.get('hasar_katsayi') || ''))));
			setCalculated(true);
		}
		
		localStorage.setItem('referrer', `${window.location.origin}${window.location.pathname}`);
	}, [location.search]);

	const calculate = () => {
		if (aracRayic && aracKilometreKatsayi && hasarMiktari && hasarKatsayi) {
			setHideAll(true);
			const aracEsasKatsayi = 0.19;
			const bazDegerKaybi = aracRayic * aracEsasKatsayi;
			const totalDegerKaybi = bazDegerKaybi * aracKilometreKatsayi * hasarKatsayi;

			const newResults = [
				{ text: "Hasar Katsayısı", value: hasarKatsayi },
				{ text: "Kullanılmışlık Düzeyi Katsayısı", value: aracKilometreKatsayi },
				{ text: "Araç Değer Kaybı", value: totalDegerKaybi },
			];

			setResults(newResults);

			const params = new URLSearchParams({
				results: btoa(encodeURIComponent(JSON.stringify(newResults))),
				hasar_miktari: btoa(encodeURIComponent(hasarMiktari.toString())),
				arac_rayic: btoa(encodeURIComponent(aracRayic.toString())),
				hasar_katsayi: btoa(encodeURIComponent(hasarKatsayi.toString())),
				arac_kilometre_katsayi: btoa(encodeURIComponent(aracKilometreKatsayi.toString())),
			});

			navigate(`${window.location.pathname}?${params.toString()}`);
			navigate(0);
		} else {
			alert("Lütfen tüm değerleri doğru girdiğinizden emin olunuz!");
		}
	};

	return (
		<>
			<Helmet>
				<title>Araç Değer Kaybı Hesaplama - Legalbul</title>
				<link rel="canonical" href={`${window.location.origin}${window.location.pathname}`} />
				<meta name="description" content="Araç değer kaybı hesaplama, bir aracın hasar görmesi sonucu piyasa değerinin düşmesini belirlemek için yapılan bir işlemdir." />
			</Helmet>
            
            <Header />
			<section className="container my-5 bg-white shadow-sm p-0">
				<div className="p-4">
					<ol className="breadcrumbnav">
						<li>
							<Link to="/">Ana Sayfa</Link>
						</li>
						<li>
							<Link to="/hesaplamalar">Tüm Hesaplamalar</Link>
						</li>
						<li>Araç Değer Kaybı Hesapla</li>
					</ol>
					<h1 className="fw-semibold">Araç Değer Kaybı Hesapla</h1>
					<p>Araç değer kaybı hesaplama, bir aracın hasar görmesi sonucu piyasa değerinin düşmesini belirlemek için yapılan bir işlemdir. Detaylı bilgi için <Link to="https://www.legalbul.com/blog/arac-deger-kaybi-nedir" target="_blank" className="text-orange">blog yazımızı</Link> inceleyebilirsiniz.</p>

					<Dropdown selectedOption={aracKilometreKatsayi} options={ARAC_DEGER_OPTIONS} label="Aracın Kilometresi" setSelectedOption={setAracKilometreKatsayi} />
					<Dropdown selectedOption={hasarKatsayi} options={ARAC_DEGER_HASAR_BOYUTLARI} label="Aracın Hasar Boyutu" setSelectedOption={setHasarKatsayi} />
					<InputField value={aracRayic} setValue={setAracRayic} trailText="TL" label="Araç Rayiç" type="number" />
					<InputField value={hasarMiktari} setValue={setHasarMiktari} trailText="TL" label="Hasar Miktarı" type="number" />
				</div>

				<CalculationResultPart calculated={calculated} hideAll={hideAll} results={results} calculate={calculate} />
			</section>
			
			<Footer faqs={faqs} faqTitle="Araç Değer Kaybı Hakkında Bilmeniz Gerekenler" />
		</>
  	);
};

export default React.memo(AracDegerKaybiHesaplama);
